module.exports = __webpack_public_path__ + "static/media/dropbox.825d99bc.svg";